enum EUserTypes {
  Admin = 'ADMIN',
  Integration = 'INTEGRACAO',
  Preview = 'VISUALIZACAO',
}

export default EUserTypes;
